module.exports = __webpack_public_path__ + "static/adewunmi-dee06c245d4d5b1401b8c5f03e47e265.png";